import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Kontaktperson from './Kontaktperson.jsx'
import KontaktpersonIcon from '../../../images/Eier kontaktperson.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class KontaktpersonList extends Component {
    state = {
        kontaktpersoner: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getKontaktpersoner = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/kontaktperson`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                kontaktpersoner: [...this.state.kontaktpersoner, ...data.kontaktpersoner],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }


    toggleKontaktpersoner = () => {
        if (this.props.antall == 0) return

        if (this.state.kontaktpersoner.length == 0) {
            this.getKontaktpersoner()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallKontaktpersoner = this.state.continuationToken ? `${this.state.kontaktpersoner.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleKontaktpersoner}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={KontaktpersonIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('kontaktpersoner')} ({antallKontaktpersoner})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.kontaktpersoner.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.kontaktpersoner.map((k, index) => { return (<Kontaktperson key={k.kontaktpersonId} kontaktperson={k} antall={this.props.antall} isLast={index==this.state.kontaktpersoner.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getKontaktpersoner}>
                                <span>{t('hent.kontaktpersoner')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KontaktpersonList)